import React from 'react';
class Footer extends React.Component {

    constructor(props) {
        super(props);

        this.url = process.env.REACT_APP_API_URL;
        this.buildEnv = process.env.REACT_APP_CUST_APP_ENV;
        this.buildVersion = process.env.REACT_APP_CUST_APP_VERSION;


        this.footerStyle = {
            backgroundColor: "#757573",
            fontSize: "20px",
            color: "white",
            borderTop: "1px solid #E7E7E7",
            textAlign: "center",
            padding: "20px",
            position: "fixed",
            left: "0",
            bottom: "0",
            height: "50px",
            width: "100%"
        };

        this.phantomStyle = {
            display: "block",
            padding: "1px",
            height: "1px",
            width: "100%"
        };
    }

    render() {
        return (
            <div>
                <div style={this.phantomStyle} />
                <div style={this.footerStyle}>{this.buildEnv} - {this.buildVersion}</div>
            </div>
        );
    }
}

export {Footer}
